export const Separator = () => <div className="border-t mt-40" />;
